module.exports = __webpack_public_path__ + "img/logo.39594d65.svg";